import { useCallback, type ReactNode } from "react";
import { search_events } from "src/store/features/events-slice";
import { useDispatch } from "react-redux";
import SearchBar from "src/components/common/SearchBar";

export interface EventsHeaderProps {
  statusFilterSlot?: ReactNode;
  onSearchChange?: (value: string) => void;
}

const EventsHeader = ({ statusFilterSlot, onSearchChange }: EventsHeaderProps) => {
  const dispatch = useDispatch();

  const handleEventsSearch = useCallback(
    (searchEventValue: string) => {
      if (onSearchChange) {
        onSearchChange(searchEventValue);
      } else {
        dispatch(search_events(searchEventValue));
      }
    },
    [dispatch, onSearchChange]
  );

  return (
    <div className="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3">
      <div className="min-w-0 w-full sm:flex-1 sm:max-w-[260px]">
        <SearchBar placeholder="Search event by name..." onChange={handleEventsSearch} />
      </div>
      {statusFilterSlot != null ? (
        <div className="w-full min-w-0 sm:w-auto sm:shrink-0">{statusFilterSlot}</div>
      ) : null}
    </div>
  );
};

export default EventsHeader;
